import { render, staticRenderFns } from "./NavbarLanguageSelector.vue?vue&type=template&id=718d48fd&scoped=true"
import script from "./NavbarLanguageSelector.vue?vue&type=script&lang=ts"
export * from "./NavbarLanguageSelector.vue?vue&type=script&lang=ts"
import style0 from "./NavbarLanguageSelector.vue?vue&type=style&index=0&id=718d48fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718d48fd",
  null
  
)

export default component.exports